import { Component, ErrorInfo, ReactNode } from 'react';

// Sem isso, qualquer excecao de render em QUALQUER tela derruba a arvore
// inteira do React e a pagina fica em branco, sem nenhuma pista pro usuario.
export default class ErrorBoundary extends Component<{ children: ReactNode }, { erro: Error | null }> {
  state: { erro: Error | null } = { erro: null };

  static getDerivedStateFromError(erro: Error) {
    return { erro };
  }

  componentDidCatch(erro: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', erro, info.componentStack);
  }

  render() {
    if (this.state.erro) {
      return (
        <div style={{ maxWidth: 480, margin: '80px auto', padding: 24, textAlign: 'center' }}>
          <h2>Algo deu errado nesta tela</h2>
          <p style={{ color: 'var(--texto-suave, #64748b)' }}>
            Recarregue a página. Se o problema continuar, avise o suporte.
          </p>
          <button className="btn" style={{ marginTop: 12 }} onClick={() => window.location.reload()}>
            Recarregar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
